import styled from 'styled-components';

export const Box = styled.div`
  margin-top: 20px;
  border-top: 1px solid ${({ theme }) => theme.palette.primary.border};
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  background-color: ${({ theme }) => theme.palette.primary.background};
`;
